import { IoCContainer } from '@lmnop/web-core';
import {
    AngularWebsiteCoreIoCKeys,
    AngularWebsiteCoreIoCContainer,
} from 'angular-website-core-src';

//IoCContainer.bind START
IoCContainer.bindSingletonType(
    AngularWebsiteCoreIoCKeys.IAngularWebsiteCoreIoCContainer,
    AngularWebsiteCoreIoCContainer
);
//IoCContainer.bind END

export * from './angular-website-core-src';
